"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tableau_expression_parser_js_1 = require("@tableau/tableau-expression-parser-js");
var React = require("react");
var StyleFunctions_1 = require("../../style/StyleFunctions");
var TableauExpressionFunctions_1 = require("../functions/TableauExpressionFunctions");
var TableauExpressionFormatter = /** @class */ (function (_super) {
    __extends(TableauExpressionFormatter, _super);
    function TableauExpressionFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderToken = function (token, index) {
            if (token.text) {
                var text = token.text;
                switch (token.type) {
                    case tableau_expression_parser_js_1.TableauExpressionLexer.COMMENT:
                        return _this.renderTokenText(text, index, stringClass);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.FIELDNAME:
                        return _this.renderFieldName(text, index);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.IDENTIFIER:
                        return _this.renderIdentifier(text, index);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.STRINGLITERAL:
                        return _this.renderTokenText(text, index, stringClass);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.LCBRACK:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.RCBRACK:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.COLON:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.FIXED:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.INCLUDE:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.EXCLUDE:
                        return _this.renderTokenText(text, index, functionClass);
                    default:
                        return _this.renderTokenText(text, index);
                }
            }
            else {
                return null;
            }
        };
        return _this;
    }
    TableauExpressionFormatter.prototype.render = function () {
        var tokens = TableauExpressionFunctions_1.tokensFromTableauExpression(this.props.expression);
        return (React.createElement("span", { className: expressionClass }, tokens.map(this.renderToken)));
    };
    TableauExpressionFormatter.prototype.renderFieldName = function (text, index) {
        var name = TableauExpressionFunctions_1.trimBrackets(text);
        return this.renderFieldOrParameter(name, text, index);
    };
    TableauExpressionFormatter.prototype.renderIdentifier = function (text, index) {
        var name = text;
        return this.renderFieldOrParameter(name, text, index);
    };
    TableauExpressionFormatter.prototype.renderFieldOrParameter = function (name, text, index) {
        var fieldInfo = getFieldByName(name, this.props.fields);
        if (fieldInfo) {
            return (React.createElement("a", { key: index, className: fieldNameClass, href: this.props.makeFieldUrl(fieldInfo.id), target: this.props.openLinksInNewTab ? '_blank' : undefined }, text));
        }
        else {
            var parameterInfo = getParameterByName(name, this.props.parameters);
            if (parameterInfo) {
                return this.renderTokenText(text, index, parameterClass);
            }
            else {
                return this.renderTokenText(text, index);
            }
        }
    };
    TableauExpressionFormatter.prototype.renderTokenText = function (text, index, className) {
        return (React.createElement("span", { key: index, className: className }, text));
    };
    return TableauExpressionFormatter;
}(React.Component));
exports.TableauExpressionFormatter = TableauExpressionFormatter;
var fieldNameStyle = {
    color: '#f18a34',
    textDecoration: 'none',
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
        }
    }
};
var functionStyle = {
    color: '#377e9c',
};
var parameterStyle = {
    color: '#936eb0',
};
var stringStyle = {
    color: '#717171',
};
var fieldNameClass = StyleFunctions_1.cssClass('TableauExpression_FieldName', fieldNameStyle);
var functionClass = StyleFunctions_1.cssClass('TableauExpression_Function', functionStyle);
var parameterClass = StyleFunctions_1.cssClass('TableauExpression_Parameter', parameterStyle);
var stringClass = StyleFunctions_1.cssClass('TableauExpression_String', stringStyle);
var expressionStyle = {
    fontFamily: 'Courier New, monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    $nest: (_a = {},
        _a["a." + fieldNameClass] = {
            color: '#f18a34',
        },
        _a)
};
var expressionClass = StyleFunctions_1.cssClass('TableauExpression_Expression', expressionStyle);
function getFieldByName(name, fields) {
    if (fields) {
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var fieldInfo = fields_1[_i];
            if (fieldInfo.name && fieldInfo.name === name) {
                return fieldInfo;
            }
        }
    }
    return null;
}
function getParameterByName(name, parameters) {
    if (parameters) {
        for (var _i = 0, parameters_1 = parameters; _i < parameters_1.length; _i++) {
            var parameterInfo = parameters_1[_i];
            if (parameterInfo.name && parameterInfo.name === name) {
                return parameterInfo;
            }
        }
    }
    return null;
}
//# sourceMappingURL=TableauExpressionFormatter.js.map